"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconCurrencyPoundCircle = /*#__PURE__*/
function (_Icon) {
  _inherits(IconCurrencyPoundCircle, _Icon);
  function IconCurrencyPoundCircle(props) {
    var _this;
    _classCallCheck(this, IconCurrencyPoundCircle);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconCurrencyPoundCircle).call(this, props));
    _this.name = 'IconCurrencyPoundCircle';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "currency-pound-circle_svg__group0"
    }, _react2.default.createElement("path", {
      className: "currency-pound-circle_svg__path0",
      d: "M12.004 24c-6.617 0-12-5.383-12-12s5.383-12 12-12 12 5.383 12 12-5.383 12-12 12zm0-23c-6.065 0-11 4.935-11 11s4.935 11 11 11 11-4.935 11-11-4.935-11-11-11z"
    }), _react2.default.createElement("path", {
      className: "currency-pound-circle_svg__path1",
      d: "M8.5 17a.5.5 0 010-1c.995 0 1.5-1.009 1.5-3v-1H8.004a.5.5 0 010-1H10V8.5C10 7.121 11.121 6 12.5 6 13.878 6 15 7.121 15 8.5a.5.5 0 01-1 0c0-.827-.673-1.5-1.5-1.5S11 7.673 11 8.5V11h2.004a.5.5 0 010 1H11v1c0 1.32-.221 2.325-.657 3H14.5a.5.5 0 010 1h-6z"
    })));
    return _this;
  }
  return IconCurrencyPoundCircle;
}(_Icon3.default);
exports.default = IconCurrencyPoundCircle;